import { useId } from 'react';
import S from './DropdownFilterStyles';

type Props = {
  option: Record<string, string>;
  handleSearch: (value: string) => void;
  checkedState: string;
  onClick?: any;
};

function RadioSearchOption({
  option,
  handleSearch,
  checkedState,
  onClick,
}: Props):JSX.Element {
  const id = useId();
  const [value, label] = Object.entries(option)[0] as [string, string];
  const isChecked = checkedState === value;

  return (
    <S.SearchItemWrapper
      onClick={() => {
        handleSearch(value);
        onClick();
      }}
    >
      <input type="radio" name={`sort-by-${value}-${id}`} id={id} checked={isChecked} disabled />
      <label htmlFor={id}><span className="checkbox" />{label}</label>
    </S.SearchItemWrapper>
  );
}

export default RadioSearchOption;
